// extracted by mini-css-extract-plugin
module.exports = {"removeIconForKidsList":"A4","removeIcon":"A5 yn"};